// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ff5236efadf8e643bffb59a6fc47229eb91be300/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};